import _Object$getPrototypeOf from "babel-runtime/core-js/object/get-prototype-of";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { Fragment } from "react";
import { compose, withStateHandlers } from "recompose";
import styled from "styled-components";
import Transition from "react-transition-group/Transition";

import { Button, LegalPanel, PANEL_DURATION_IN_MS } from "./style";

export default styled(compose(withStateHandlers({ isOpen: false }, {
  show: function show() {
    return function () {
      return { isOpen: true };
    };
  },
  hide: function hide() {
    return function () {
      return { isOpen: false };
    };
  }
}))(function (_React$Component) {
  _inherits(LegalButton, _React$Component);

  function LegalButton() {
    _classCallCheck(this, LegalButton);

    return _possibleConstructorReturn(this, (LegalButton.__proto__ || _Object$getPrototypeOf(LegalButton)).apply(this, arguments));
  }

  _createClass(LegalButton, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isOpen = _props.isOpen,
          show = _props.show,
          hide = _props.hide,
          children = _props.children;


      return React.createElement(
        Fragment,
        null,
        React.createElement(
          Transition,
          { "in": isOpen, timeout: PANEL_DURATION_IN_MS },
          function (state) {
            return children({ state: state, hide: hide });
          }
        ),
        React.createElement(Button, { onClick: show, className: className })
      );
    }
  }]);

  return LegalButton;
}(React.Component))).withConfig({
  componentId: "udoz8b-0"
})([""]);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/LegalButton/index.js
// module id = 102
// module chunks = 0